import { render } from "./DesignDataComponent.vue?vue&type=template&id=d30ddbe4"
import script from "./DesignDataComponent.vue?vue&type=script&lang=js"
export * from "./DesignDataComponent.vue?vue&type=script&lang=js"

import "./DesignDataComponent.vue?vue&type=style&index=0&id=d30ddbe4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__